import type { ReactNode } from "react";

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

export default function PageHeader({ eyebrow, title, subtitle, children }: PageHeaderProps) {
  return (
    <section className="relative w-full pt-36 pb-16 md:pt-44 md:pb-20 bg-background-100/70 overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 lg:px-12 flex flex-col items-start gap-5">
        <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-primary-600">
          {eyebrow}
        </span>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-tight text-foreground-900 max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="max-w-2xl text-base md:text-lg text-foreground-500 leading-relaxed">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}